/** projects.casting.com is the same bundle under a different brand, so the prefix follows the host. */
export const getAppTitle = (hostname = window.location.hostname) =>
  hostname.includes('projects.casting.com') ? 'Casting Projects' : 'Agency App';

export const formatDocumentTitle = (pageName?: string | null) => {
  const name = pageName?.trim();
  return name ? `${getAppTitle()} - ${name}` : getAppTitle();
};

// Most specific first; a page that knows a better name (a project's) overrides this via setPageTitle.
const PAGE_NAME_BY_ROUTE: Array<[RegExp, string]> = [
  [/^\/(packages|projects)\/quick-submit\//, 'Quick Submit'],
  [/^\/projects\/casting_projects\/packages/, 'Packages'],
  [/^\/projects\/casting_projects\/create-detailed/, 'Create Package'],
  [/^\/projects\/casting_projects\/[^/]+\/edit-detailed/, 'Edit Package'],
  [/^\/projects\/casting_projects\/[^/]+\/roles/, 'Roles'],
  [/^\/projects/, 'Projects'],
  [/^\/packages/, 'Packages'],
  [/^\/worksheet/, 'Worksheet'],
  [/^\/overview/, 'Overview'],
  [/^\/talent/, 'Talent'],
  [/^\/reports/, 'Reports'],
  [/^\/settings/, 'Settings'],
  [/^\/login/, 'Login'],
];

export const getRoutePageName = (pathname: string) =>
  PAGE_NAME_BY_ROUTE.find(([pattern]) => pattern.test(pathname))?.[1] ?? '';
